import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CircularProgress from '@mui/joy/CircularProgress';

import Autocomplete from '@mui/joy/Autocomplete';
import { API_PATH, handleApiResponse } from '../Internal/api.js';


export default function PDGSearchbar({ onParticleSelect, includeMass = false, includeWidth = false }) {
    const dispatch = useDispatch();
    const pdgParticles = useSelector(state => state.pdgParticles.particles);

    const api_query = API_PATH + "pdg_particles";
    useEffect(() => {
        if (pdgParticles !== null) {
            return;
        }
        fetch(api_query)
        .then(response => handleApiResponse(response, dispatch))
        .then(data => {
            dispatch({ type: 'SET_PDG_PARTICLES', payload: data.particles });
        })
        .catch(error => {
            console.error('Error:', error);
        });
    }, []);

    const handleParticleSelect = (newValue) => {
        if (newValue) {
            // Create a result object with spin, parity, and optionally mass and width
            const result = {
                label: newValue.label,
                spin: newValue.spin,
                parity: newValue.parity !== 0 ? newValue.parity : null
            };
            
            // Include mass if requested and available
            if (includeMass && newValue.mass !== undefined && newValue.mass !== null) {
                result.mass = newValue.mass;
            }
            
            // Include width if requested and available
            if (includeWidth && newValue.width !== undefined && newValue.width !== null) {
                result.width = newValue.width;
            }
            
            onParticleSelect(result);
        }
    };

    return (<Autocomplete
                    variant="soft"
                    placeholder="Select PDG Particle"
                    options={pdgParticles}
                    disabled={pdgParticles === null}
                    sx={{ width: 300 }}
                    onChange={(e, newValue) => handleParticleSelect(newValue)}
                    loading={pdgParticles === null}
                    endDecorator={
                        pdgParticles === null ? (
                          <CircularProgress size="sm" sx={{ bgcolor: 'background.surface' }} />
                        ) : null
                      }              
                />);
}